import { render } from "./Apoiador.vue?vue&type=template&id=55e16876&scoped=true"
import script from "./Apoiador.vue?vue&type=script&lang=js"
export * from "./Apoiador.vue?vue&type=script&lang=js"

import "./Apoiador.vue?vue&type=style&index=0&id=55e16876&lang=css"
import "./Apoiador.vue?vue&type=style&index=1&id=55e16876&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e16876"]])

export default __exports__